import React, { useState } from "react";
import { Button } from "../../atom/Button";
import { useHistory } from "react-router-dom";
import { Input } from "../../atom/Input";
import { API_URL } from '../../../config/api'

export const Login = () => {
  const history = useHistory();
  const [info, setInfo] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (info.email.length === 0) {
      setError("Emailが入力されていません");
      return;
    }

    if (info.password.length === 0) {
      setError("Passwordが入力されていません");
      return;
    }

    // response -> string型
    // '{"status": "success"}'
    const response = await fetch(`${API_URL}/api/users/login`, {
      // credentials: 'include',
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(info),
    })

    // response.status -> 200, 400

    // '{"status": "success"}'.json() -> { status : "success"}
    // json string型をjavascriptのオブジェクトに変換する
    const resJavascript = await response.json();

    if (resJavascript.status === "success") {
      localStorage.setItem("token", resJavascript.token);
      history.push("/");
    } else {
      setError(resJavascript.message);
    }
  };
  return (
    <div className="login">
      <div className="login--inner">
        <div className="login__content">
          <div className="login__header">
            <div className="login__header--inner">
              <div style={{ width: 300 }}>
                <h1>{error}</h1>
                <div>
                  <p style={{ fontSize: 15 }}>
                    アカウントをお持ちでない方はこちら
                  </p>
                </div>
                <div className="login__signup">
                  <a href="/signup" className="login__signup--anchor">
                    <div className="login__signup--content">
                      <h3 style={{ fontSize: 14, color: "white" }}>
                        新規会員登録
                      </h3>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="buttons">
            <div className="button__wrapper">
              <Button
                type="auth"
                platform="google"
                customize={{
                  backgroundColor: "black",
                  border: "1px solid black",
                }}
                fullWidth
              />
            </div>
            <div className="button__wrapper">
              <Button type="auth" platform="facebook" fullWidth />
            </div>
            <div className="button__wrapper">
              <Button type="auth" placeform="apple" fullWidth />
            </div>
            <div>{info.error}</div>
            <form
              method="post"
              onSubmit={handleSubmit}
              style={{ width: "100%" }}
            >
              <div style={{ marginTop: 30, width: "100%" }}>
                <div style={{ margin: "10px 0" }}>
                  <Input
                    type="auth"
                    data={info.email}
                    setData={(e) => setInfo({ ...info, email: e.target.value })}
                    placeholder="メールアドレス"
                  />
                </div>
                <div style={{ margin: "10px 0" }}>
                  <Input
                    type="auth"
                    data={info.password}
                    setData={(e) =>
                      setInfo({ ...info, password: e.target.value })
                    }
                    placeholder="パスワード"
                  />
                </div>
              </div>
              <div className="button__block">
                <a href="/signup" className="button__anchor">
                  <div className="button__content">
                    <input type="submit" value="ログイン" />
                  </div>
                </a>
              </div>
            </form>
            <div style={{ width: "100%", margin: "8px 0" }}>
              <a href="/signup" className="forgot__password">
                パスワードをお忘れの方
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
